import React from 'react'
import Form from 'react-bootstrap/Form';

function AddPrescription() {
  return (
   <>
   <div>
    <p>sduhasbsx</p>
   </div>
   </>
  )
}

export default AddPrescription